import { useMemo } from 'react';

import { changeSetReducer } from 'hb-react/shared/components/User/UpdateInformationModal/utils/changesetReducer';

export const useUserDataSubscriber = (
  { user, formState },
  customAttributes = [],
) => {
  const changeSet = useMemo(() => {
    if (!user) {
      return [];
    }

    return changeSetReducer(
      { user, formState },
      customAttributes,
    ).getChangeSet();
  }, [user, formState]);

  return {
    isModified: changeSet.length > 0,
    changeSet,
  };
};
